<template>
	<div id="app">

        <div class="card border-primary" style="margin-bottom:20px;">
			<div class="card-header">
				<h5 style="margin-bottom:0px;">BetRadar NBA Scores</h5>
			</div>
			<div class="card-body">
				<div class="form-row">
					<div class="col">
						<div class="form-group">
							<label>Year</label>
							<select @change="selectYear" class="form-control">
								<option value="">-- Select --</option>
								<option value="2017">2017</option>
                                <option value="2018">2018</option>
                                <option value="2019" selected>2019</option>
                                <option value="2020">2020</option>
							</select>
						</div>
					</div>
					<div class="col">
						<div class="form-group">
							<label>Season</label>
							<select @change="selectSeason" class="form-control">
								<option value="">-- Select --</option>
								<option value="PRE">PRE - Pre-season</option>
                                <option value="REG" selected>REG - Regular season</option>
                                <option value="PST">PST - Past season</option>
							</select>
						</div>
					</div>
                    <div class="col">
						<div class="form-group" v-if="schedule.games">
							<label>Games</label>
							<select @change="selectSportEvent" class="form-control">
								<option value="">-- Select --</option>
                                <option v-for="sport_event in schedule.games" :value="sport_event.id">
                                    {{ sport_event.scheduled }} - {{ sport_event.status }} - {{ getSportEventName(sport_event) }}
                                </option>
							</select>
						</div>
					</div>
				</div>
				
				<div>
					<p>These are the BetRadar endpoints used to build this page.</p>
					<table class="table" style="text-align:left;">
						<tr>
							<td>Schedule</td>
							<td>
                                <a :href="getScheduleEndpoint(true)" target="_blank">{{ getScheduleEndpoint(true) }}</a>
                            </td>
						</tr>
                        <tr v-if="getPlayByPlayEndpoint()">
                            <td>Play by Play</td>
							<td>
                                <a :href="getPlayByPlayEndpoint(true)" target="_blank">{{ getPlayByPlayEndpoint(true) }}</a>
                            </td>
                        </tr>
                        <tr v-if="getGameBoxscoreEndpoint()">
                            <td>Game Boxscore</td>
							<td>
                                <a :href="getGameBoxscoreEndpoint(true)" target="_blank">{{ getGameBoxscoreEndpoint(true) }}</a>
                            </td>
                        </tr>
                        <tr v-if="getGameSummaryEndpoint()">
                            <td>Game Summary</td>
							<td>
                                <a :href="getGameSummaryEndpoint(true)" target="_blank">{{ getGameSummaryEndpoint(true) }}</a>
                            </td>
                        </tr>
                        <tr v-if="getInjuriesEndpoint()">
                            <td>Injuries</td>
							<td>
                                <a :href="getInjuriesEndpoint(true)" target="_blank">{{ getInjuriesEndpoint(true) }}</a>
                            </td>
                        </tr>
                        <tr v-if="getTeamRosterEndpoint(this.home)">
                            <td>Team Roster Home Team</td>
							<td>
                                <a :href="getTeamRosterEndpoint(this.home, true)" target="_blank">{{ getTeamRosterEndpoint(this.home, true) }}</a>
                            </td>
                        </tr>
                        <tr v-if="getTeamRosterEndpoint(this.away)">
                            <td>Team Roster Away Team</td>
							<td>
                                <a :href="getTeamRosterEndpoint(this.away, true)" target="_blank">{{ getTeamRosterEndpoint(this.away, true) }}</a>
                            </td>
                        </tr>
                        <tr v-if="getSeasonalStatisticsEndpoint(this.home)">
                            <td>Seasonal Statistics Home Team</td>
							<td>
                                <a :href="getSeasonalStatisticsEndpoint(this.home, true)" target="_blank">{{ getSeasonalStatisticsEndpoint(this.home, true) }}</a>
                            </td>
                        </tr>
                        <tr v-if="getTeamRosterEndpoint(this.away)">
                            <td>Seasonal Statistics Away Team</td>
							<td>
                                <a :href="getSeasonalStatisticsEndpoint(this.away, true)" target="_blank">{{ getSeasonalStatisticsEndpoint(this.away, true) }}</a>
                            </td>
                        </tr>
                        <tr v-if="getSeriesStatisticsEndpoint(this.home)">
                            <td>Series Statistics Home Team</td>
							<td>
                                <a :href="getSeriesStatisticsEndpoint(this.home, true)" target="_blank">{{ getSeriesStatisticsEndpoint(this.home, true) }}</a>
                            </td>
                        </tr>
                        <tr v-if="getSeriesStatisticsEndpoint(this.away)">
                            <td>Series Statistics Away Team</td>
							<td>
                                <a :href="getSeriesStatisticsEndpoint(this.away, true)" target="_blank">{{ getSeriesStatisticsEndpoint(this.away, true) }}</a>
                            </td>
                        </tr>
                        <tr v-if="getSplitsGameEndpoint(this.home)">
                            <td>Splits Game Home Team</td>
							<td>
                                <a :href="getSplitsGameEndpoint(this.home, true)" target="_blank">{{ getSplitsGameEndpoint(this.home, true) }}</a>
                            </td>
                        </tr>
                        <tr v-if="getSplitsGameEndpoint(this.away)">
                            <td>Splits Game Away Team</td>
							<td>
                                <a :href="getSplitsGameEndpoint(this.away, true)" target="_blank">{{ getSplitsGameEndpoint(this.away, true) }}</a>
                            </td>
                        </tr>
                        <tr v-if="getSplitsHierarchyEndpoint(this.home)">
                            <td>Splits Hierarchy Home Team</td>
							<td>
                                <a :href="getSplitsHierarchyEndpoint(this.home, true)" target="_blank">{{ getSplitsHierarchyEndpoint(this.home, true) }}</a>
                            </td>
                        </tr>
                        <tr v-if="getSplitsHierarchyEndpoint(this.away)">
                            <td>Splits Hierarchy Away Team</td>
							<td>
                                <a :href="getSplitsHierarchyEndpoint(this.away, true)" target="_blank">{{ getSplitsHierarchyEndpoint(this.away, true) }}</a>
                            </td>
                        </tr>
                        <tr v-if="getSplitsScheduleEndpoint(this.home)">
                            <td>Splits Schedule Home Team</td>
							<td>
                                <a :href="getSplitsScheduleEndpoint(this.home, true)" target="_blank">{{ getSplitsScheduleEndpoint(this.home, true) }}</a>
                            </td>
                        </tr>
                        <tr v-if="getSplitsScheduleEndpoint(this.away)">
                            <td>Splits Schedule Away Team</td>
							<td>
                                <a :href="getSplitsScheduleEndpoint(this.away, true)" target="_blank">{{ getSplitsScheduleEndpoint(this.away, true) }}</a>
                            </td>
                        </tr>
                        <tr v-if="getSplitsInGameEndpoint(this.home)">
                            <td>Splits In-game Home Team</td>
							<td>
                                <a :href="getSplitsInGameEndpoint(this.home, true)" target="_blank">{{ getSplitsInGameEndpoint(this.home, true) }}</a>
                            </td>
                        </tr>
                        <tr v-if="getSplitsInGameEndpoint(this.away)">
                            <td>Splits In-game Away Team</td>
							<td>
                                <a :href="getSplitsInGameEndpoint(this.away, true)" target="_blank">{{ getSplitsInGameEndpoint(this.away, true) }}</a>
                            </td>
                        </tr>
                        <tr v-if="getCompetitorSummariesEndpoint(this.competitor_sr_id_home)">
                            <td>Competitors Summaries Home Team</td>
							<td>
                                <a :href="getCompetitorSummariesEndpoint(this.competitor_sr_id_home, true)" target="_blank">{{ getCompetitorSummariesEndpoint(this.competitor_sr_id_home, true) }}</a>
                            </td>
                        </tr>
                        <tr v-if="getCompetitorSummariesEndpoint(this.competitor_sr_id_away)">
                            <td>Competitors Summaries Away Team</td>
							<td>
                                <a :href="getCompetitorSummariesEndpoint(this.competitor_sr_id_away, true)" target="_blank">{{ getCompetitorSummariesEndpoint(this.competitor_sr_id_away, true) }}</a>
                            </td>
                        </tr>
                        <tr v-if="getH2HEndpoint()">
                            <td>Competitor vs Competitor</td>
							<td>
                                <a :href="getH2HEndpoint(true)" target="_blank">{{ getH2HEndpoint(true) }}</a>
                            </td>
                        </tr>
					</table>
				</div>
				
			</div>
		</div>

        <div v-if="sportEventId">
            <div id="accordion">
                <div class="card">
					<div class="card-header" id="headingOne">
						<h5 class="mb-0">
							<button class="btn btn-link" data-toggle="collapse" data-target="#game" aria-expanded="true" aria-controls="collapseOne">
							Game
							</button>
						</h5>
					</div>

					<div id="game" class="collapse show" aria-labelledby="headingOne">
						<div class="card-body">
							
							<table class="table">
                                <tr>
                                    <th>scheduled</th>
                                    <th>home</th>
                                    <th>away</th>
                                    <th>venue</th>
                                    <th>broadcasts</th>
                                </tr>
                                <tr v-if="sport_event">
                                    <td>
                                        {{ sport_event.scheduled }}<br>
                                        id: {{ sport_event.id }}<br>
                                        status: {{ sport_event.status }}
                                    </td>
                                    <td>
                                        name: {{ sport_event.home.name }}<br>
                                        alias: {{ sport_event.home.alias }}<br>
                                        id: {{ sport_event.home.id }}<br>
                                        sr_id: {{ sport_event.home.sr_id }}<br>
                                        reference: {{ sport_event.home.reference }}<br>
                                    </td>
                                    <td>
                                        name: {{ sport_event.away.name }}<br>
                                        alias: {{ sport_event.away.alias }}<br>
                                        id: {{ sport_event.away.id }}<br>
                                        sr_id: {{ sport_event.away.sr_id }}<br>
                                        reference: {{ sport_event.away.reference }}<br>
                                    </td>
                                    <td>
                                        name: {{ sport_event.venue.name }}<br>
                                        id: {{ sport_event.venue.id }}<br>
                                        address: {{ sport_event.venue.address }}<br>
                                        city: {{ sport_event.venue.city }}<br>
                                        state: {{ sport_event.venue.state }}<br>
                                        country: {{ sport_event.venue.country }}<br>
                                        zip: {{ sport_event.venue.zip }}<br>
                                        capacity: {{ sport_event.venue.capacity }}<br>
                                        surface: {{ sport_event.venue.surface }}<br>
                                        type: {{ sport_event.venue.type }}<br>
                                    </td>
                                    <td>
                                        <div v-if="sport_event.broadcasts">
                                            <div v-for="broadcast in sport_event.broadcasts">
                                                network: {{ broadcast.network }}<br>
                                                channel: {{ broadcast.channel }}<br>
                                                locale: {{ broadcast.locale }}<br>
                                                type: {{ broadcast.type }}<br>
                                            </div>
                                            
                                        </div>
                                    </td>
                                </tr>
                            </table>

						</div>
					</div>
				</div>

                <div class="card" v-if="play_by_play != []">
					<div class="card-header" id="headingOne">
						<h5 class="mb-0">
							<button class="btn btn-link" data-toggle="collapse" data-target="#playbyplay" aria-expanded="true" aria-controls="collapseOne">
							Play by Play
							</button>
						</h5>
					</div>

					<div id="playbyplay" class="collapse show" aria-labelledby="headingOne">
						<div class="card-body">
							
							<table class="table">
                                <tr>
                                    <th></th>
                                    <th>home</th>
                                    <th>away</th>
                                    <th>time_zones</th>
                                </tr>
                                <tr>
                                    <td>
                                        duration: {{ play_by_play.duration }}<br>
                                        attendance: {{ play_by_play.attendance }}<br>
                                        lead_changes: {{ play_by_play.lead_changes }}<br>
                                        times_tied: {{ play_by_play.times_tied }}<br>
                                    </td>
                                    <td>
                                        <div v-if="play_by_play.home">
                                            id: {{ play_by_play.home.id }}<br>
                                            market: {{ play_by_play.home.market }}<br>
                                            name: {{ play_by_play.home.name }}<br>
                                            points: {{ play_by_play.home.points }}<br>
                                            bonus: {{ play_by_play.home.bonus }}<br>
                                        </div>
                                    </td>
                                    <td>
                                        <div v-if="play_by_play.away">
                                            id: {{ play_by_play.away.id }}<br>
                                            market: {{ play_by_play.away.market }}<br>
                                            name: {{ play_by_play.away.name }}<br>
                                            points: {{ play_by_play.away.points }}<br>
                                            bonus: {{ play_by_play.away.bonus }}<br>
                                        </div>
                                    </td>
                                    <td>
                                        <div v-if="play_by_play.time_zones">
                                            venue: {{ play_by_play.time_zones.venue }}<br>
                                            home: {{ play_by_play.time_zones.home }}<br>
                                            away: {{ play_by_play.time_zones.away }}<br>
                                        </div>
                                    </td>
                                </tr>
                            </table>

                            <div v-for="period in play_by_play.periods">

                                <h3>Period - {{ period.number}}</h3>

                                home score: {{ period.scoring.home.points }}<br>
                                away score: {{ period.scoring.away.points }}<br>
                                lead_changes: {{ period.scoring.lead_changes }}<br>
                                times_tied: {{ period.scoring.times_tied }}<br>

                                <table class="table">
                                    <tr>
                                        <th>clock</th>
                                        <th></th>
                                        <th>points</th>
                                        <th>location</th>
                                        <th>on_court home</th>
                                        <th>on_court away</th>
                                        <th>statistics</th>  
                                    </tr>
                                    <tr v-for="pbp in period.events">
                                        <td>{{ pbp.clock }}</td>
                                        <td v-if="pbp">
                                            id: {{ pbp.id }}<br>
                                            <span v-if="pbp.type"> type: {{ pbp.type }}<br></span>
                                            <span v-if="pbp.event_type"> event_type: {{ pbp.event_type }}<br></span>
                                            <span v-if="pbp.sequence"> sequence: {{ pbp.sequence }}<br></span>
                                            <span v-if="pbp.description"> summary: {{ pbp.description }}<br></span>
                                            <span v-if="pbp.updated"> updated: {{ pbp.updated }}<br></span>
                                            <span v-if="pbp.number"> number: {{ pbp.number }}<br></span>
                                            <span v-if="pbp.wall_clock"> wall_clock: {{ pbp.wall_clock }}<br></span>
                                            
                                            <div v-if="pbp.attribution">
                                                attribution: {{ pbp.attribution.market }} {{ pbp.attribution.name }}
                                            </div>
                                        </td>
                                        <td>
                                            <span v-if="pbp.home_points"> home_points: {{ pbp.home_points }}<br></span>
                                            <span v-if="pbp.away_points"> away_points: {{ pbp.away_points }}<br></span>
                                        </td>
                                        <td>
                                            <div v-if="pbp.location">
                                                <span v-if="pbp.location.action_area"> action_area: {{ pbp.location.action_area }}<br></span>
                                                <span v-if="pbp.location.coord_x"> coord_x: {{ pbp.location.coord_x }}<br></span>
                                                <span v-if="pbp.location.coord_y"> coord_y: {{ pbp.location.coord_y }}<br></span>
                                            </div>
                                        </td>
                                        <td>
                                            <div v-if=" pbp.on_court">
                                                <div v-for="player in pbp.on_court.home.players">
                                                    {{ player.full_name }} - jersey: {{ player.jersey_number }}
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div v-if=" pbp.on_court">
                                                <div v-for="player in pbp.on_court.away.players">
                                                    {{ player.full_name }} - jersey: {{ player.jersey_number }}
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div v-if="pbp.statistics">

                                                <div v-for="pbpstat in pbp.statistics" style="border-bottom:1px solid #ccc;">
                                                    type: {{ pbpstat.type }}<br>
                                                    <span v-if="pbpstat.made">made: {{ pbpstat.made }}<br></span>
                                                    <span v-if="pbpstat.shot_type">shot_type: {{ pbpstat.shot_type }}<br></span>
                                                    <span v-if="pbpstat.shot_type_desc">shot_type_desc: {{ pbpstat.shot_type_desc }}<br></span>
                                                    <span v-if="pbpstat.points">points: {{ pbpstat.points }}<br></span>
                                                    <span v-if="pbpstat.shot_distance">shot_distance: {{ pbpstat.shot_distance }}<br></span>
                                                    <span v-if="pbpstat.team">team: {{ pbpstat.team.name }}<br></span>
                                                    <span v-if="pbpstat.player">player: {{ pbpstat.player.full_name }}<br></span>
                                                </div>

                                            </div>
                                        </td>
                                    </tr>
                                </table>
                            </div>
						</div>
					</div>
				</div>

                <div class="card" v-if="game_boxscore != []">
					<div class="card-header" id="headingOne">
						<h5 class="mb-0">
							<button class="btn btn-link" data-toggle="collapse" data-target="#game-boxscore" aria-expanded="true" aria-controls="collapseOne">
							Game Boxscore
							</button>
						</h5>
					</div>

					<div id="game-boxscore" class="collapse show" aria-labelledby="headingOne">
						<div class="card-body">
							
							<table class="table">
                                <tr>
                                    <th></th>
                                    <th>home team scoring</th>
                                    <th>away team scoring</th>
                                </tr>
                                <tr>
                                    <td>
                                        completed: {{ game_boxscore.completed }}<br>
                                        clock: {{ game_boxscore.clock }}<br>
                                        quarter: {{ game_boxscore.quarter }}<br>
                                        status: {{ game_boxscore.status }}<br>
                                    </td>
                                    <td>
                                        
                                        <div v-if="game_boxscore.home">
                                            points: {{ game_boxscore.home.points }}<br>
                                            <div v-for="scoring in game_boxscore.home.scoring" style="border-top: 1px solid #ccc">
                                                points: {{ scoring.points }}<br>
                                                type: {{ scoring.type }}<br>
                                                number: {{ scoring.number }}<br>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        
                                        <div v-if="game_boxscore.away">
                                            points: {{ game_boxscore.away.points }}<br>
                                            <div v-for="scoring in game_boxscore.away.scoring" style="border-top: 1px solid #ccc">
                                                points: {{ scoring.points }}<br>
                                                type: {{ scoring.type }}<br>
                                                number: {{ scoring.number }}<br>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </table>

                            <h3>leaders</h3>

                            <table class="table" v-if="game_boxscore.home">
                                <tr>
                                    <th></th>
                                    <th>home</th>
                                    <th>away</th>
                                </tr>
                                <tr>
                                    <td>
                                        points
                                    </td>
                                    <td>
                                        <div v-for="player in game_boxscore.home.leaders.points">
                                            full_name: {{ player.full_name }}<br>
                                            jersey_number: {{ player.jersey_number }}<br>
                                            position: {{ player.position }}<br>
                                            primary_position: {{ player.primary_position }}<br>
                                            id: {{ player.id }}<br>
                                            sr_id: {{ player.sr_id }}<br>
                                            <span v-for="field in game_boxscore_leader_statistic_fields">
                                                {{ field }}: {{ player.statistics[field] }}<br>
                                            </span>
                                        </div>
                                    </td>
                                    <td>
                                        <div v-for="player in game_boxscore.away.leaders.points">
                                            full_name: {{ player.full_name }}<br>
                                            jersey_number: {{ player.jersey_number }}<br>
                                            position: {{ player.position }}<br>
                                            primary_position: {{ player.primary_position }}<br>
                                            id: {{ player.id }}<br>
                                            sr_id: {{ player.sr_id }}<br>
                                            <span v-for="field in game_boxscore_leader_statistic_fields">
                                                {{ field }}: {{ player.statistics[field] }}<br>
                                            </span>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        rebounds
                                    </td>
                                    <td>
                                        <div v-for="player in game_boxscore.home.leaders.rebounds">
                                            full_name: {{ player.full_name }}<br>
                                            jersey_number: {{ player.jersey_number }}<br>
                                            position: {{ player.position }}<br>
                                            primary_position: {{ player.primary_position }}<br>
                                            id: {{ player.id }}<br>
                                            sr_id: {{ player.sr_id }}<br>
                                            <span v-for="field in game_boxscore_leader_statistic_fields">
                                                {{ field }}: {{ player.statistics[field] }}<br>
                                            </span>
                                        </div>
                                    </td>
                                    <td>
                                        <div v-for="player in game_boxscore.away.leaders.rebounds">
                                            full_name: {{ player.full_name }}<br>
                                            jersey_number: {{ player.jersey_number }}<br>
                                            position: {{ player.position }}<br>
                                            primary_position: {{ player.primary_position }}<br>
                                            id: {{ player.id }}<br>
                                            sr_id: {{ player.sr_id }}<br>
                                            <span v-for="field in game_boxscore_leader_statistic_fields">
                                                {{ field }}: {{ player.statistics[field] }}<br>
                                            </span>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        assists
                                    </td>
                                    <td>
                                        <div v-for="player in game_boxscore.home.leaders.assists">
                                            full_name: {{ player.full_name }}<br>
                                            jersey_number: {{ player.jersey_number }}<br>
                                            position: {{ player.position }}<br>
                                            primary_position: {{ player.primary_position }}<br>
                                            id: {{ player.id }}<br>
                                            sr_id: {{ player.sr_id }}<br>
                                            <span v-for="field in game_boxscore_leader_statistic_fields">
                                                {{ field }}: {{ player.statistics[field] }}<br>
                                            </span>
                                        </div>
                                    </td>
                                    <td>
                                        <div v-for="player in game_boxscore.away.leaders.assists">
                                            full_name: {{ player.full_name }}<br>
                                            jersey_number: {{ player.jersey_number }}<br>
                                            position: {{ player.position }}<br>
                                            primary_position: {{ player.primary_position }}<br>
                                            id: {{ player.id }}<br>
                                            sr_id: {{ player.sr_id }}<br>
                                            <span v-for="field in game_boxscore_leader_statistic_fields">
                                                {{ field }}: {{ player.statistics[field] }}<br>
                                            </span>
                                        </div>
                                    </td>
                                </tr>
                            </table>
						</div>
					</div>
				</div>

                <div class="card" v-if="game_summary != []">
					<div class="card-header" id="headingOne">
						<h5 class="mb-0">
							<button class="btn btn-link" data-toggle="collapse" data-target="#game-summary" aria-expanded="true" aria-controls="collapseOne">
							Game Summary
							</button>
						</h5>
					</div>

					<div id="game-summary" class="collapse show" aria-labelledby="headingOne">
						<div class="card-body">
							
                            <h3>home_team</h3>

                            <table class="table" v-if="game_summary.home">
                                <tr>
                                    <th>statistics</th>
                                    <th>players</th>
                                    <th>coaches</th>
                                </tr>
                                <tr>
                                    <td>
                                        <div v-for="(value, name) in game_summary.home.statistics">
                                            <div v-if="typeof(value) == 'object'">
                                                
                                                {{ name }}: 
                                                <div v-for="(value_2, name_2) in value" style="padding-left:20px;">
                            
                                                    <div v-if="typeof(value_2) == 'object'">
                                                
                                                        {{ name_2 }}: 
                                                        <div v-for="(value_3, name_3) in value_2" style="padding-left:20px;">
                                                            
                                                            {{ name_3 }}: {{ value_3 }}
                                                        
                                                        </div>

                                                    </div>
                                                    <div v-else>
                                                        {{ name_2 }}: {{ value_2 }}
                                                    </div>
                                                
                                                </div>

                                            </div>
                                            <div v-else>
                                                {{ name }}: {{ value }}
                                            </div>
                                            
                                        </div> 
                                    </td>
                                    <td>
                                        <div v-for="player in game_summary.home.players">
                                            <b>{{ player.full_name}}</b>
                                            <div v-for="(value, name) in player.statistics">
                                                <div v-if="typeof(value) == 'object'">
                                                    
                                                    {{ name }}: 
                                                    <div v-for="(value_2, name_2) in value" style="padding-left:20px;">
                                
                                                        <div v-if="typeof(value_2) == 'object'">
                                                    
                                                            {{ name_2 }}: 
                                                            <div v-for="(value_3, name_3) in value_2" style="padding-left:20px;">
                                                                
                                                                {{ name_3 }}: {{ value_3 }}
                                                            
                                                            </div>

                                                        </div>
                                                        <div v-else>
                                                            {{ name_2 }}: {{ value_2 }}
                                                        </div>
                                                    
                                                    </div>

                                                </div>
                                                <div v-else>
                                                    {{ name }}: {{ value }}
                                                </div>
                                                
                                            </div> 
                                            <br><br>
                                        </div>
                                    </td>
                                    <td>
                                        <div v-for="(value, name) in game_summary.home.coaches">
                                            <div v-if="typeof(value) == 'object'">
                                                
                                                {{ name }}: 
                                                <div v-for="(value_2, name_2) in value" style="padding-left:20px;">
                            
                                                    <div v-if="typeof(value_2) == 'object'">
                                                
                                                        {{ name_2 }}: 
                                                        <div v-for="(value_3, name_3) in value_2" style="padding-left:20px;">
                                                            
                                                            {{ name_3 }}: {{ value_3 }}
                                                        
                                                        </div>

                                                    </div>
                                                    <div v-else>
                                                        {{ name_2 }}: {{ value_2 }}
                                                    </div>
                                                
                                                </div>

                                            </div>
                                            <div v-else>
                                                {{ name }}: {{ value }}
                                            </div>
                                            
                                        </div> 
                                    </td>
                                </tr>
                            </table>
                            

                            <h3>away_team</h3>

                            <table class="table" v-if="game_summary.away">
                                <tr>
                                    <th>statistics</th>
                                    <th>players</th>
                                    <th>coaches</th>
                                </tr>
                                <tr>
                                    <td>
                                        <div v-for="(value, name) in game_summary.away.statistics">
                                            <div v-if="typeof(value) == 'object'">
                                                
                                                {{ name }}: 
                                                <div v-for="(value_2, name_2) in value" style="padding-left:20px;">
                            
                                                    <div v-if="typeof(value_2) == 'object'">
                                                
                                                        {{ name_2 }}: 
                                                        <div v-for="(value_3, name_3) in value_2" style="padding-left:20px;">
                                                            
                                                            {{ name_3 }}: {{ value_3 }}
                                                        
                                                        </div>

                                                    </div>
                                                    <div v-else>
                                                        {{ name_2 }}: {{ value_2 }}
                                                    </div>
                                                
                                                </div>

                                            </div>
                                            <div v-else>
                                                {{ name }}: {{ value }}
                                            </div>
                                            
                                        </div> 
                                    </td>
                                    <td>
                                        <div v-for="player in game_summary.away.players">
                                            <b>{{ player.full_name}}</b>
                                            <div v-for="(value, name) in player.statistics">
                                                <div v-if="typeof(value) == 'object'">
                                                    
                                                    {{ name }}: 
                                                    <div v-for="(value_2, name_2) in value" style="padding-left:20px;">
                                
                                                        <div v-if="typeof(value_2) == 'object'">
                                                    
                                                            {{ name_2 }}: 
                                                            <div v-for="(value_3, name_3) in value_2" style="padding-left:20px;">
                                                                
                                                                {{ name_3 }}: {{ value_3 }}
                                                            
                                                            </div>

                                                        </div>
                                                        <div v-else>
                                                            {{ name_2 }}: {{ value_2 }}
                                                        </div>
                                                    
                                                    </div>

                                                </div>
                                                <div v-else>
                                                    {{ name }}: {{ value }}
                                                </div>
                                                
                                            </div> 
                                            <br><br>
                                        </div>
                                    </td>
                                    <td>
                                        <div v-for="(value, name) in game_summary.away.coaches">
                                            <div v-if="typeof(value) == 'object'">
                                                
                                                {{ name }}: 
                                                <div v-for="(value_2, name_2) in value" style="padding-left:20px;">
                            
                                                    <div v-if="typeof(value_2) == 'object'">
                                                
                                                        {{ name_2 }}: 
                                                        <div v-for="(value_3, name_3) in value_2" style="padding-left:20px;">
                                                            
                                                            {{ name_3 }}: {{ value_3 }}
                                                        
                                                        </div>

                                                    </div>
                                                    <div v-else>
                                                        {{ name_2 }}: {{ value_2 }}
                                                    </div>
                                                
                                                </div>

                                            </div>
                                            <div v-else>
                                                {{ name }}: {{ value }}
                                            </div>
                                            
                                        </div> 
                                    </td>
                                </tr>
                            </table>                           

						</div>
					</div>
				</div>

                <div class="card" v-if="injuries != []">
					<div class="card-header" id="headingOne">
						<h5 class="mb-0">
							<button class="btn btn-link" data-toggle="collapse" data-target="#injuries" aria-expanded="true" aria-controls="collapseOne">
							Injuries
							</button>
						</h5>
					</div>

					<div id="injuries" class="collapse show" aria-labelledby="headingOne">
						<div class="card-body">
                            
                            <table class="table">
                                <tr>
                                    <th>team</th>
                                    <th>player</th>
                                    <th>injuries</th>
                                </tr>
                                <template v-for="team in injuries.teams">
                                    <tr v-for="player in team.players">
                                        <td>{{ team.market}} {{ team.name}}</td>
                                        <td>{{ player.full_name }}</td>
                                        <td>
                                            <div v-for="injury in player.injuries">
                                                comment: {{ injury.comment }}<br>
                                                desc: {{ injury.desc }}<br>
                                                status: {{ injury.status }}<br>
                                                start_date: {{ injury.start_date }}<br>
                                                update_date: {{ injury.update_date }}<br>
                                            </div>
                                        </td>
                                    </tr>
                                </template>
                            </table>

                            <div v-if="injuries.home_team">
                                <h3>home_team</h3>

                                <table class="table">
                                    <tr>
                                        <th>name_full</th>
                                        <th>position</th>
                                        <th>jersey_number</th>
                                        <th>status</th>
                                        <th>started</th>
                                        <th>played</th>
                                        <th>start_date</th>
                                        <th>game_status</th>
                                        <th>practice_status</th>
                                        <th>description</th>
                                    </tr>
                                    <template v-for="player in injuries.home_team.players">
                                        <tr v-for="injury in player.injuries">
                                            <td>{{ player.name_full }}</td>
                                            <td>{{ player.position }}</td>
                                            <td>{{ player.jersey_number }}</td>
                                            <td>{{ player.status }}</td>
                                            <td>{{ player.started }}</td>
                                            <td>{{ player.played }}</td>
                                            <td>{{ injury.start_date }}</td>
                                            <td>{{ injury.game_status }}</td>
                                            <td>{{ injury.practice_status }}</td>
                                            <td>{{ injury.description }}</td>
                                        </tr>
                                    </template>
                                </table>  
                            </div>

                            <div v-if="injuries.home_team">
                                <h3>away_team</h3>

                                <table class="table">
                                    <tr>
                                        <th>name_full</th>
                                        <th>position</th>
                                        <th>jersey_number</th>
                                        <th>status</th>
                                        <th>started</th>
                                        <th>played</th>
                                        <th>start_date</th>
                                        <th>game_status</th>
                                        <th>practice_status</th>
                                        <th>description</th>
                                    </tr>
                                    <template v-for="player in injuries.away_team.players">
                                        <tr v-for="injury in player.injuries">
                                            <td>{{ player.name_full }}</td>
                                            <td>{{ player.position }}</td>
                                            <td>{{ player.jersey_number }}</td>
                                            <td>{{ player.status }}</td>
                                            <td>{{ player.started }}</td>
                                            <td>{{ player.played }}</td>
                                            <td>{{ injury.start_date }}</td>
                                            <td>{{ injury.game_status }}</td>
                                            <td>{{ injury.practice_status }}</td>
                                            <td>{{ injury.description }}</td>
                                        </tr>
                                    </template>
                                </table>  
                            </div>
                                            
						</div>
					</div>
				</div>

                <div class="card" v-if="team_roster_home != [] && team_roster_away != []">
					<div class="card-header" id="headingOne">
						<h5 class="mb-0">
							<button class="btn btn-link" data-toggle="collapse" data-target="#team-roster" aria-expanded="true" aria-controls="collapseOne">
							Team Roster
							</button>
						</h5>
					</div>

					<div id="team-roster" class="collapse show" aria-labelledby="headingOne">
						<div class="card-body">
							
                            <NBARoster
                                :roster="team_roster_home"
                                team_role="home_team"
                            ></NBARoster>

                            <NBARoster
                                :roster="team_roster_away"
                                team_role="away_team"
                            ></NBARoster>
                                            
						</div>
					</div>
				</div>

                <div class="card" v-if="seasonal_statistics_home != [] && seasonal_statistics_away != []">
					<div class="card-header" id="headingOne">
						<h5 class="mb-0">
							<button class="btn btn-link" data-toggle="collapse" data-target="#seasonal-statistics" aria-expanded="true" aria-controls="collapseOne">
							Seasonal Statistics
							</button>
						</h5>
					</div>

					<div id="seasonal-statistics" class="collapse show" aria-labelledby="headingOne">
						<div class="card-body">
							
                            <h3>home_team</h3>

                            <div v-if="seasonal_statistics_home">
                                <NBASeasonalStatistics
                                    :statistics="seasonal_statistics_home"
                                ></NBASeasonalStatistics>
                            </div>
                            

                            <h3>away_team</h3>

                            <div v-if="seasonal_statistics_away">
                                <NBASeasonalStatistics
                                    :statistics="seasonal_statistics_away"
                                ></NBASeasonalStatistics>
                            </div>
                                            
						</div>
					</div>
				</div>

                <div class="card" v-if="splits_game_home != [] && splits_game_away != []">
					<div class="card-header" id="headingOne">
						<h5 class="mb-0">
							<button class="btn btn-link" data-toggle="collapse" data-target="#splits-game" aria-expanded="true" aria-controls="collapseOne">
							Splits Game
							</button>
						</h5>
					</div>

					<div id="splits-game" class="collapse show" aria-labelledby="headingOne">
						<div class="card-body">
							
                            <h3>home_team</h3>

                            <div v-if="splits_game_home">

                                <div v-for="statistics in splits_game_home.splits">

                                    <h4>{{ statistics.category }}</h4>

                                    <div v-if="statistics.opponent">
                                        <h5>opponent: {{ statistics.opponent.market }} {{ statistics.opponent.name }}</h5>
                                    </div>

                                    <NBASeasonalStatistics
                                        :statistics="statistics"
                                    ></NBASeasonalStatistics>
                                </div>
                                
                            </div>
                            

                            <h3>away_team</h3>

                            <div v-if="splits_game_away">

                                <div v-for="statistics in splits_game_away.splits">

                                    <h4>{{ statistics.category }}</h4>

                                    <div v-if="statistics.opponent">
                                        <h5>opponent: {{ statistics.opponent.market }} {{ statistics.opponent.name }}</h5>
                                    </div>

                                    <NBASeasonalStatistics
                                        :statistics="statistics"
                                    ></NBASeasonalStatistics>
                                </div>
                                
                            </div>
                                            
						</div>
					</div>
				</div>

                <div class="card" v-if="splits_hierarchy_home != [] && splits_hierarchy_away != []">
					<div class="card-header" id="headingOne">
						<h5 class="mb-0">
							<button class="btn btn-link" data-toggle="collapse" data-target="#splits-hierarchy" aria-expanded="true" aria-controls="collapseOne">
							Splits Hierarchy
							</button>
						</h5>
					</div>

					<div id="splits-hierarchy" class="collapse show" aria-labelledby="headingOne">
						<div class="card-body">
							
                            <h3>home_team</h3>

                            <div v-if="splits_hierarchy_home">

                                <div v-for="statistics in splits_hierarchy_home.splits">

                                    <h4>{{ statistics.category }} <span v-if="statistics.conference">{{ statistics.conference.name }}</span></h4>

                                    <div v-if="statistics.opponent">
                                        <h5>opponent: {{ statistics.opponent.market }} {{ statistics.opponent.name }}</h5>
                                    </div>

                                    <NBASeasonalStatistics
                                        :statistics="statistics"
                                    ></NBASeasonalStatistics>
                                </div>
                                
                            </div>
                            

                            <h3>away_team</h3>

                            <div v-if="splits_hierarchy_away">

                                <div v-for="statistics in splits_hierarchy_away.splits">

                                    <h4>{{ statistics.category }} <span v-if="statistics.conference">{{ statistics.conference.name }}</span></h4>

                                    <div v-if="statistics.opponent">
                                        <h5>opponent: {{ statistics.opponent.market }} {{ statistics.opponent.name }}</h5>
                                    </div>

                                    <NBASeasonalStatistics
                                        :statistics="statistics"
                                    ></NBASeasonalStatistics>
                                </div>
                                
                            </div>
                                            
						</div>
					</div>
				</div>

                <div class="card" v-if="splits_schedule_home != [] && splits_schedule_away != []">
					<div class="card-header" id="headingOne">
						<h5 class="mb-0">
							<button class="btn btn-link" data-toggle="collapse" data-target="#splits-schedule" aria-expanded="true" aria-controls="collapseOne">
							Splits Schedule
							</button>
						</h5>
					</div>

					<div id="splits-schedule" class="collapse show" aria-labelledby="headingOne">
						<div class="card-body">
							
                            <h3>home_team</h3>

                            <div v-if="splits_schedule_home">

                                <div v-for="statistics in splits_schedule_home.splits">

                                    <h4>{{ statistics.category }} 
                                        <span v-if="statistics.days_of_rest">{{ statistics.days_of_rest }}</span>
                                        <span v-if="statistics.day_of_week">{{ statistics.day_of_week }}</span>
                                        <span v-if="statistics.month">{{ statistics.month }}</span>
                                        <span v-if="statistics.week">{{ statistics.week }}</span>
                                    </h4>

                                    <div v-if="statistics.opponent">
                                        <h5>opponent: {{ statistics.opponent.market }} {{ statistics.opponent.name }}</h5>
                                    </div>

                                    <NBASeasonalStatistics
                                        :statistics="statistics"
                                    ></NBASeasonalStatistics>
                                </div>
                                
                            </div>
                            

                            <h3>away_team</h3>

                            <div v-if="splits_schedule_away">

                                <div v-for="statistics in splits_schedule_away.splits">

                                    <h4>{{ statistics.category }} <span v-if="statistics.conference">{{ statistics.conference.name }}</span></h4>

                                    <div v-if="statistics.opponent">
                                        <h5>opponent: {{ statistics.opponent.market }} {{ statistics.opponent.name }}</h5>
                                    </div>

                                    <NBASeasonalStatistics
                                        :statistics="statistics"
                                    ></NBASeasonalStatistics>
                                </div>
                                
                            </div>
                                            
						</div>
					</div>
				</div>

                <div class="card" v-if="splits_ingame_home != [] && splits_ingame_away != []">
					<div class="card-header" id="headingOne">
						<h5 class="mb-0">
							<button class="btn btn-link" data-toggle="collapse" data-target="#splits-ingame" aria-expanded="true" aria-controls="collapseOne">
							Splits In-Game
							</button>
						</h5>
					</div>

					<div id="splits-ingame" class="collapse show" aria-labelledby="headingOne">
						<div class="card-body">
							
                            <h3>home_team</h3>

                            <div v-if="splits_ingame_home">

                                <div v-for="statistics in splits_ingame_home.splits">

                                    <h4>{{ statistics.category }}</h4>

                                    <div v-if="statistics.opponent">
                                        <h5>opponent: {{ statistics.opponent.market }} {{ statistics.opponent.name }}</h5>
                                    </div>

                                    <NBASeasonalStatistics
                                        :statistics="statistics"
                                    ></NBASeasonalStatistics>
                                </div>
                                
                            </div>
                            

                            <h3>away_team</h3>

                            <div v-if="splits_ingame_away">

                                <div v-for="statistics in splits_ingame_away.splits">

                                    <h4>{{ statistics.category }} <span v-if="statistics.conference">{{ statistics.conference.name }}</span></h4>

                                    <div v-if="statistics.opponent">
                                        <h5>opponent: {{ statistics.opponent.market }} {{ statistics.opponent.name }}</h5>
                                    </div>

                                    <NBASeasonalStatistics
                                        :statistics="statistics"
                                    ></NBASeasonalStatistics>
                                </div>
                                
                            </div>
                                            
						</div>
					</div>
				</div>

                <div class="card" v-if="team_roster_home != [] && team_roster_away != []">
                    <div class="card-header" id="headingFive">
                        <h5 class="mb-0">
                            <button class="btn btn-link" data-toggle="collapse" data-target="#collapsePlayerProfile" aria-expanded="true" aria-controls="collapseOne">
                            Player Profile
                            </button>
                        </h5>
                    </div>

                    <div id="collapsePlayerProfile" class="collapse show" aria-labelledby="collapseFour">
                        <div class="card-body">

                            <select class="form-control" @change="selectPlayer">
                                <option value="">-- Select --</option>
                                <option v-for="player in team_roster_home.players" :value="player.id">
                                    {{ player.full_name }}
                                </option>
                                <option v-for="player in team_roster_away.players" :value="player.id">
                                    {{ player.full_name }}
                                </option>
                            </select>
                            
                            <div v-if="player_profile">

                                <table class="table">
                                    <tr>
                                        <th>id</th>
                                        <th>last_name</th>
                                        <th>first_name</th>
                                        <th>birthdate</th>
                                        <th>birth_place</th>
                                        <th>height</th>
                                        <th>weight</th>
                                        <th>college</th>
                                        <th>draft</th>
                                        <th>experience</th>
                                        <th>jersey_number</th>
                                        <th>position</th>
                                        <th>primary_position</th>
                                        <th>status</th>
                                        <th>team</th>
                                        <th>draft</th>
                                    </tr>
                                    <tr>
                                        <td>{{ player_profile.id }}</td>
                                        <td>{{ player_profile.last_name }}</td>
                                        <td>{{ player_profile.first_name }}</td>
                                        <td>{{ player_profile.birthdate }}</td>
                                        <td>{{ player_profile.birth_place }}</td>
                                        <td>{{ player_profile.height }}</td>
                                        <td>{{ player_profile.weight }}</td>
                                        <td>{{ player_profile.college }}</td>
                                        <td>{{ player_profile.draft }}</td>
                                        <td>{{ player_profile.experience }}</td>
                                        <td>{{ player_profile.jersey_number }}</td>
                                        <td>{{ player_profile.position }}</td>
                                        <td>{{ player_profile.primary_position }}</td>
                                        <td>{{ player_profile.status }}</td>
                                        <td>
                                            <span v-if="player_profile.team">
                                                {{ player_profile.team.market }} {{ player_profile.team.name }}
                                            </span>
                                        </td>
                                        <td>
                                            <span v-if="player_profile.draft">
                                                pick: {{ player_profile.draft.pick }}<br>
                                                round: {{ player_profile.draft.round }}<br>
                                                year: {{ player_profile.draft.year }}<br>
                                            </span>
                                        </td>
                                    </tr>
                                </table>

                                <h3>seasons</h3>

                                <table class="table" v-if="player_profile.seasons">
                                    <tr>
                                        <th>year</th>
                                        <th>type</th>
                                        <th>team</th>
                                        <th>total</th>
                                        <th>average</th>
                                    </tr>
                                    <template v-for="season in player_profile.seasons">
                                        <tr v-for="team in season.teams">
                                            <td>{{ season.year }}</td>
                                            <td>{{ season.type }}</td>
                                            <td>{{ team.market }} {{ team.name }}</td>
                                            <td>
                                                <div v-for="value, name in team.total">
                                                    {{ name }}: {{ value }}
                                                </div>
                                            </td>
                                            <td>
                                                <div v-for="value, name in team.average">
                                                    {{ name }}: {{ value }}
                                                </div>
                                            </td>
                                        </tr>
                                    </template>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card" v-if="competitor_summaries_home != [] && competitor_summaries_away != []">
					<div class="card-header" id="headingOne">
						<h5 class="mb-0">
							<button class="btn btn-link" data-toggle="collapse" data-target="#competitor-summaries" aria-expanded="true" aria-controls="collapseOne">
							Competitors Summaries
							</button>
						</h5>
					</div>
                    <div id="competitor-summaries" class="collapse show" aria-labelledby="headingOne">
						<div class="card-body">

                            <h3>Home team</h3>
                            <h4>
                                {{ sport_event.home.name }}<br>
                            </h4>
                            <h5>
                                alias: {{ sport_event.home.alias }}<br>
                                id: {{ sport_event.home.id }}<br>
                                sr_id: {{ sport_event.home.sr_id }}<br>
                            </h5>
                            <table class="table">
                                <tr>
                                    <th>score</th>
                                    <th>date</th>
                                    <th>competitors names</th>
                                    <th>winner</th>
                                </tr>
                                <template v-if="new Date(summary.sport_event.start_time) < Date.now()" v-for="summary in competitor_summaries_home.summaries" >
                                    <tr v-if="summary.sport_event_status">
                                        <td>
                                            {{summary.sport_event_status.home_score}}-{{summary.sport_event_status.away_score}}                                        
                                        </td>
                                        <td>
                                            {{summary.sport_event.start_time}}                                       
                                        </td>
                                        <td>
                                            {{summary.sport_event.competitors[0].name}} vs  {{summary.sport_event.competitors[1].name}}                                      
                                        </td>
                                        <td v-if="summary.sport_event_status.winner_id == summary.sport_event.competitors[0].id">
                                            {{summary.sport_event.competitors[0].name}}                                       
                                        </td>
                                        <td v-if="summary.sport_event_status.winner_id == summary.sport_event.competitors[1].id">
                                            {{summary.sport_event.competitors[1].name}}                                       
                                        </td>
                                        <td v-if="summary.sport_event_status.winner_id == null">
                                            DRAW                                     
                                        </td>
                                    </tr>    
                                </template>
                            </table>
                            <h3>Away team</h3>
                            <h4>
                                {{ sport_event.away.name }}<br>
                            </h4>
                            <h5>
                                alias: {{ sport_event.away.alias }}<br>
                                id: {{ sport_event.away.id }}<br>
                                sr_id: {{ sport_event.away.sr_id }}<br>
                            </h5>
                            <table class="table">
                                <tr>
                                    <th>score</th>
                                    <th>date</th>
                                    <th>competitors names</th>
                                    <th>winner</th>
                                </tr>
                                <template v-if="new Date(summary.sport_event.start_time) < Date.now()" v-for="summary in competitor_summaries_away.summaries" >
                                    <tr v-if="summary.sport_event_status">
                                        <td>
                                            {{summary.sport_event_status.away_score}}-{{summary.sport_event_status.away_score}}                                        
                                        </td>
                                        <td>
                                            {{summary.sport_event.start_time}}                                       
                                        </td>
                                        <td>
                                            {{summary.sport_event.competitors[0].name}} vs  {{summary.sport_event.competitors[1].name}}                                      
                                        </td>
                                        <td v-if="summary.sport_event_status.winner_id == summary.sport_event.competitors[0].id">
                                            {{summary.sport_event.competitors[0].name}}                                       
                                        </td>
                                        <td v-if="summary.sport_event_status.winner_id == summary.sport_event.competitors[1].id">
                                            {{summary.sport_event.competitors[1].name}}                                       
                                        </td>
                                        <td v-if="summary.sport_event_status.winner_id == null">
                                            DRAW                                     
                                        </td>
                                    </tr>   
                                        
                                </template>
                            </table>
                        </div>
                    </div>
                </div>

                <div class="card" v-if="h2h != []">
					<div class="card-header" id="headingOne">
						<h5 class="mb-0">
							<button class="btn btn-link" data-toggle="collapse" data-target="#h2h" aria-expanded="true" aria-controls="collapseOne">
							Competitor vs Competitor
							</button>
						</h5>
					</div>

					<div id="h2h" class="collapse show" aria-labelledby="headingOne">
						<div class="card-body">
							
                            <div v-if="h2h.last_meetings && h2h.competitors">
                            <h3>{{h2h.competitors[0].name}} vs {{h2h.competitors[1].name}}</h3>
                                <table class="table">
                                    <tr>
                                        <th>Scheduled</th>
                                        <th>Venue</th>
                                        <th>Home</th>
                                        <th>Away</th>
                                        <th>Home score</th>
                                        <th>Away score</th>
                                        <th>Winner</th>
                                    </tr>
                                    <tr v-for="meeting in h2h.last_meetings" v-if="meeting.sport_event && meeting.sport_event_status">
                                        <td>{{meeting.sport_event.start_time}}</td>
                                        <td v-if="meeting.sport_event.venue">{{meeting.sport_event.venue.name}} in {{meeting.sport_event.venue.city_name}}</td>
                                        <td v-if="!meeting.sport_event.venue">-</td>
                                        <template v-if="meeting.sport_event.competitors[0].qualifier == 'home'">
                                            <td>{{meeting.sport_event.competitors[0].name}}</td>
                                            <td>{{meeting.sport_event.competitors[1].name}}</td>
                                        </template>
                                        <template v-if="meeting.sport_event.competitors[1].qualifier == 'home'">
                                            <td>{{meeting.sport_event.competitors[1].name}}</td>
                                            <td>{{meeting.sport_event.competitors[0].name}}</td>
                                        </template>
                                        <td>{{meeting.sport_event_status.home_score}}</td>
                                        <td>{{meeting.sport_event_status.away_score}}</td>
                                        <td v-if="meeting.sport_event_status.winner_id == meeting.sport_event.competitors[0].id">{{meeting.sport_event.competitors[0].name}}</td>
                                        <td v-if="meeting.sport_event_status.winner_id == meeting.sport_event.competitors[1].id">{{meeting.sport_event.competitors[1].name}}</td>
                                        <td v-if="meeting.sport_event_status.home_score == meeting.sport_event_status.away_score">DRAW</td>
                                    </tr>
                                </table>  
                            </div>
						</div>
					</div>
				</div>
            </div>
        </div>
    </div>
</template>

<script>

import axios from 'axios'
import NBARoster from './components/NBARoster.vue'
import NBASeasonalStatistics from './components/NBASeasonalStatistics.vue'

export default {
    name: 'app',
    components: {
        NBARoster,
        NBASeasonalStatistics,
	},
    created: function() {

        this.loadSchedule();
    
    },
    data: function() {
        return {            
            apiKey: 'c35guurt2ystkshn7szzxhp8',
            globalApiKey: 'jyr8sbw66b48pg6qmn7jr6hz',
            year: 2019,
            season: "REG",
            schedule: [],
            play_by_play: [],
            sportEventId: '',
            sport_event: '',
            home: '',
            away: '',
            competitor_sr_id_home: '',
            competitor_sr_id_away: '',
            game_boxscore: [],
            game_summary: [],
            injuries: [],
            seasonal_statistics_home: [],
            seasonal_statistics_away: [],
            splits_game_home: [],
            splits_game_away: [],
            splits_hierarchy_home: [],
            splits_hierarchy_away: [],
            splits_schedule_home: [],
            splits_schedule_away: [],
            splits_ingame_home: [],
            splits_ingame_away: [],
            team_depth_chart_home: [],
            team_depth_chart_away: [],
            team_roster_home: [],
            team_roster_away: [],
            competitor_summaries_home: [],
            competitor_summaries_away: [],
            h2h: [],
            game_boxscore_leader_statistic_fields: [
                'minutes',
                'field_goals_made',
                'field_goals_att',
                'field_goals_pct',
                'three_points_made',
                'three_points_att',
                'three_points_pct',
                'two_points_made',
                'two_points_att',
                'two_points_pct',
                'blocked_att',
                'free_throws_made',
                'free_throws_att',
                'free_throws_pct',
                'offensive_rebounds',
                'defensive_rebounds',
                'rebounds',
                'assists',
                'turnovers',
                'steals',
                'blocks',
                'assists_turnover_ratio',
                'personal_fouls',
                'tech_fouls',
                'flagrant_fouls',
                'pls_min',
                'points',
                'double_double',
                'triple_double',
                'effective_fg_pct',
                'efficiency',
                'efficiency_game_score',
                'points_in_paint',
                'points_in_paint_att',
                'points_in_paint_made',
                'points_in_paint_pct',
                'true_shooting_att',
                'true_shooting_pct',
                'fouls_drawn',
                'offensive_fouls',
                'points_off_turnovers',
                'second_chance_pts',
            ],
            playerId: '',
            player_profile: [],
        }
    }, 
    methods: {
        getScheduleEndpoint: function(showBetradarUrl = false) {
            let url = `https://kaxmatrix.com/oddsapi/nba/production/v5/en/games/${this.year}/${this.season}/schedule.json?api_key=${this.apiKey}`;

            if(showBetradarUrl) {
                url = url.replace('https://kaxmatrix.com/oddsapi', 'https://api.sportradar.us');
            }

            return url;
        },

        getPlayByPlayEndpoint: function(showBetradarUrl = false) {

            // no game selected
            if(this.sportEventId == '') {
                return '';
            }

            if(this.sport_event.status != 'inprogress'
                && this.sport_event.status != 'complete'
                && this.sport_event.status != 'closed'
            ) {
                return '';
            }

            let url = `https://kaxmatrix.com/oddsapi/nba/production/v5/en/games/${this.sportEventId}/pbp.json?api_key=${this.apiKey}`;

            if(showBetradarUrl) {
                url = url.replace('https://kaxmatrix.com/oddsapi', 'https://api.sportradar.us');
            }

            return url;
        },

        getGameBoxscoreEndpoint: function(showBetradarUrl = false) {

            // no game selected
            if(this.sportEventId == '') {
                return '';
            }

            if(this.sport_event.status != 'inprogress'
                && this.sport_event.status != 'complete'
                && this.sport_event.status != 'closed'
            ) {
                return '';
            }

            let url = `https://kaxmatrix.com/oddsapi/nba/production/v5/en/games/${this.sportEventId}/boxscore.json?api_key=${this.apiKey}`;

            if(showBetradarUrl) {
                url = url.replace('https://kaxmatrix.com/oddsapi', 'https://api.sportradar.us');
            }

            return url;
        },

        getGameSummaryEndpoint: function(showBetradarUrl = false) {

            // no game selected
            if(this.sportEventId == '') {
                return '';
            }

            if(this.sport_event.status != 'inprogress'
                && this.sport_event.status != 'complete'
                && this.sport_event.status != 'closed'
            ) {
                return '';
            }

            let url = `https://kaxmatrix.com/oddsapi/nba/production/v5/en/games/${this.sportEventId}/summary.json?api_key=${this.apiKey}`;

            if(showBetradarUrl) {
                url = url.replace('https://kaxmatrix.com/oddsapi', 'https://api.sportradar.us');
            }

            return url;
        },

        getInjuriesEndpoint: function(showBetradarUrl = false) {

            let url = `https://kaxmatrix.com/oddsapi/nba/production/v5/en/league/injuries.json?api_key=${this.apiKey}`;

            if(showBetradarUrl) {
                url = url.replace('https://kaxmatrix.com/oddsapi', 'https://api.sportradar.us');
            }

            return url;
        },

        getSeasonalStatisticsEndpoint: function(team, showBetradarUrl = false) {
            
            if(team == '') return '';
            
            let url = `https://kaxmatrix.com/oddsapi/nba/production/v5/en/seasons/${this.year}/${this.season}/teams/${team.id}/statistics.json?api_key=${this.apiKey}`;

            if(showBetradarUrl) {
                url = url.replace('https://kaxmatrix.com/oddsapi', 'https://api.sportradar.us');
            }

            return url;
        },

        getSeriesStatisticsEndpoint: function(team, showBetradarUrl = false) {
            
            if(team == '') return '';
            
            let url = `https://kaxmatrix.com/oddsapi/nba/production/v5/en/series/${this.year}/${this.season}/teams/${team.id}/statistics.json?api_key=${this.apiKey}`;

            if(showBetradarUrl) {
                url = url.replace('https://kaxmatrix.com/oddsapi', 'https://api.sportradar.us');
            }

            return url;
        },

        getTeamRosterEndpoint: function(team, showBetradarUrl = false) {

            if(team == '') return '';

            let url = `https://kaxmatrix.com/oddsapi/nba/production/v5/en/teams/${team.id}/profile.json?api_key=${this.apiKey}`;

            if(showBetradarUrl) {
                url = url.replace('https://kaxmatrix.com/oddsapi', 'https://api.sportradar.us');
            }

            return url;
        },

        getSplitsGameEndpoint: function(team, showBetradarUrl = false) {

            if(team == '') return '';

            let url = `https://kaxmatrix.com/oddsapi/nba/production/v5/en/seasons/${this.year}/${this.season}/teams/${team.id}/splits/game.json?api_key=${this.apiKey}`;

            if(showBetradarUrl) {
                url = url.replace('https://kaxmatrix.com/oddsapi', 'https://api.sportradar.us');
            }

            return url;
        },

        getSplitsHierarchyEndpoint: function(team, showBetradarUrl = false) {

            if(team == '') return '';

            let url = `https://kaxmatrix.com/oddsapi/nba/production/v5/en/seasons/${this.year}/${this.season}/teams/${team.id}/splits/hierarchy.json?api_key=${this.apiKey}`;

            if(showBetradarUrl) {
                url = url.replace('https://kaxmatrix.com/oddsapi', 'https://api.sportradar.us');
            }

            return url;
        },

        getSplitsScheduleEndpoint: function(team, showBetradarUrl = false) {

            if(team == '') return '';

            let url = `https://kaxmatrix.com/oddsapi/nba/production/v5/en/seasons/${this.year}/${this.season}/teams/${team.id}/splits/schedule.json?api_key=${this.apiKey}`;

            if(showBetradarUrl) {
                url = url.replace('https://kaxmatrix.com/oddsapi', 'https://api.sportradar.us');
            }

            return url;
        },

        getSplitsInGameEndpoint: function(team, showBetradarUrl = false) {

            if(team == '') return '';

            let url = `https://kaxmatrix.com/oddsapi/nba/production/v5/en/seasons/${this.year}/${this.season}/teams/${team.id}/splits/ingame.json?api_key=${this.apiKey}`;

            if(showBetradarUrl) {
                url = url.replace('https://kaxmatrix.com/oddsapi', 'https://api.sportradar.us');
            }

            return url;
        },

        getPlayerProfileEndpoint: function(showBetradarUrl = false) {
			let url = `https://kaxmatrix.com/oddsapi/nba/production/v5/en/players/${this.playerId}/profile.json?api_key=${this.apiKey}`;

			if(showBetradarUrl) {
				url = url.replace('https://kaxmatrix.com/oddsapi', 'https://api.sportradar.us');
			}

			return url;
		},

        getCompetitorSummariesEndpoint: function(sr_id, showBetradarUrl = false) {

            if(sr_id == '') return '';

            let url = `https://kaxmatrix.com/oddsapi/basketball/production/v2/en/competitors/${sr_id}/summaries.json?api_key=${this.globalApiKey}`;

            if(showBetradarUrl) {
                url = url.replace('https://kaxmatrix.com/oddsapi', 'https://api.sportradar.us');
            }

            return url;
        },

        getH2HEndpoint: function(showBetradarUrl = false) {

            // no game selected
            if(this.competitor_sr_id_home == '' || this.competitor_sr_id_away == '')  return ''

            let url = `https://kaxmatrix.com/oddsapi/basketball/production/v2/en/competitors/${this.competitor_sr_id_home}/versus/${this.competitor_sr_id_away}/summaries.json?api_key=${this.globalApiKey}`;

            if(showBetradarUrl) {
                url = url.replace('https://kaxmatrix.com/oddsapi', 'https://api.sportradar.us');
            }

            return url;
        },

        loadSchedule: function() {

            // get full list of tournaments
            axios.get(this.getScheduleEndpoint(), 
                { crossdomain: true })
            .then((response) => {
                
                console.log('schedule', response.data);

                this.schedule = response.data;
                    
            
            }, (error) => {
                console.log(error)
            });
        },

        loadPlayByPlay: function() {

            if(this.getPlayByPlayEndpoint() == '') return;

            axios.get(this.getPlayByPlayEndpoint(), 
                { crossdomain: true })
            .then((response) => {
                
                console.log('play-by-play', response.data);

                this.play_by_play = response.data;
            
            }, (error) => {
                console.log(error)
            });
        },

        loadGameBoxscore: function() {

            if(this.getGameBoxscoreEndpoint() == '') return;

            axios.get(this.getGameBoxscoreEndpoint(), 
                { crossdomain: true })
            .then((response) => {
                
                console.log('game-boxscore', response.data);

                this.game_boxscore = response.data;
            
            }, (error) => {
                console.log(error)
            });
        },

        loadGameSummary: function() {

            if(this.getGameSummaryEndpoint() == '') return;

            axios.get(this.getGameSummaryEndpoint(), 
                { crossdomain: true })
            .then((response) => {
                
                console.log('game-summary', response.data);

                this.game_summary = response.data;
            
            }, (error) => {
                console.log(error)
            });
        },

        loadInjuries: function() {

            if(this.getInjuriesEndpoint() == '') return;

            axios.get(this.getInjuriesEndpoint(), 
                { crossdomain: true })
            .then((response) => {
                
                console.log('injuries', response.data);

                this.injuries = response.data;
            
            }, (error) => {
                console.log(error)
            });
        },

        loadSeasonalStatistics: function() {

            if(this.getSeasonalStatisticsEndpoint(this.home) == ''
                || this.getSeasonalStatisticsEndpoint(this.away) == ''
            ) return;

            axios.get(this.getSeasonalStatisticsEndpoint(this.home), 
                { crossdomain: true })
            .then((response) => {
                
                console.log('seasonal_statistics_home', response.data);

                this.seasonal_statistics_home = response.data;
            
            }, (error) => {
                console.log(error)
            });

            axios.get(this.getSeasonalStatisticsEndpoint(this.away), 
                { crossdomain: true })
            .then((response) => {
                
                console.log('seasonal_statistics_away', response.data);

                this.seasonal_statistics_away = response.data;
            
            }, (error) => {
                console.log(error)
            });
        },

        loadSplitsGame: function() {

            if(this.getSplitsGameEndpoint(this.home) == ''
                || this.getSplitsGameEndpoint(this.away) == ''
            ) return;

            axios.get(this.getSplitsGameEndpoint(this.home), 
                { crossdomain: true })
            .then((response) => {
                
                console.log('splits_game_home', response.data);

                this.splits_game_home = response.data;
            
            }, (error) => {
                console.log(error)
            });

            axios.get(this.getSplitsGameEndpoint(this.away), 
                { crossdomain: true })
            .then((response) => {
                
                console.log('splits_game_away', response.data);

                this.splits_game_away = response.data;
            
            }, (error) => {
                console.log(error)
            });
        },

        loadSplitsHierarchy: function() {

            if(this.getSplitsHierarchyEndpoint(this.home) == ''
                || this.getSplitsHierarchyEndpoint(this.away) == ''
            ) return;

            axios.get(this.getSplitsHierarchyEndpoint(this.home), 
                { crossdomain: true })
            .then((response) => {
                
                console.log('splits_hierarchy_home', response.data);

                this.splits_hierarchy_home = response.data;
            
            }, (error) => {
                console.log(error)
            });

            axios.get(this.getSplitsHierarchyEndpoint(this.away), 
                { crossdomain: true })
            .then((response) => {
                
                console.log('splits_hierarchy_away', response.data);

                this.splits_hierarchy_away = response.data;
            
            }, (error) => {
                console.log(error)
            });
        },

        loadSplitsSchedule: function() {

            if(this.getSplitsScheduleEndpoint(this.home) == ''
                || this.getSplitsScheduleEndpoint(this.away) == ''
            ) return;

            axios.get(this.getSplitsScheduleEndpoint(this.home), 
                { crossdomain: true })
            .then((response) => {
                
                console.log('splits_schedule_home', response.data);

                this.splits_schedule_home = response.data;
            
            }, (error) => {
                console.log(error)
            });

            axios.get(this.getSplitsScheduleEndpoint(this.away), 
                { crossdomain: true })
            .then((response) => {
                
                console.log('splits_schedule_away', response.data);

                this.splits_schedule_away = response.data;
            
            }, (error) => {
                console.log(error)
            });
        },

        loadSplitsInGame: function() {

            if(this.getSplitsInGameEndpoint(this.home) == ''
                || this.getSplitsInGameEndpoint(this.away) == ''
            ) return;

            axios.get(this.getSplitsInGameEndpoint(this.home), 
                { crossdomain: true })
            .then((response) => {
                
                console.log('splits_ingame_home', response.data);

                this.splits_ingame_home = response.data;
            
            }, (error) => {
                console.log(error)
            });

            axios.get(this.getSplitsInGameEndpoint(this.away), 
                { crossdomain: true })
            .then((response) => {
                
                console.log('splits_ingame_away', response.data);

                this.splits_ingame_away = response.data;
            
            }, (error) => {
                console.log(error)
            });
        },

        loadTeamRoster: function() {

            if(this.getTeamRosterEndpoint(this.home) == ''
                || this.getTeamRosterEndpoint(this.away) == ''
            ) return;

            axios.get(this.getTeamRosterEndpoint(this.home), 
                { crossdomain: true })
            .then((response) => {
                
                console.log('team_roster_home', response.data);

                this.team_roster_home = response.data;
            
            }, (error) => {
                console.log(error)
            });

            axios.get(this.getTeamRosterEndpoint(this.away), 
                { crossdomain: true })
            .then((response) => {
                
                console.log('team_roster_away', response.data);

                this.team_roster_away = response.data;
            
            }, (error) => {
                console.log(error)
            });
        },

        loadPlayerProfile: function() {

			axios.get(this.getPlayerProfileEndpoint(), 
                { crossdomain: true })
            .then((response) => {
				
				console.log('playerProfile', response.data);
				this.player_profile = response.data;

            }, (error) => {
                console.log(error)
			});

		},

        loadCompetitorSummaries: function() {
            if(this.getCompetitorSummariesEndpoint(this.competitor_sr_id_home) == ''
                || this.getCompetitorSummariesEndpoint(this.competitor_sr_id_away) == ''
            ) return;

            axios.get(this.getCompetitorSummariesEndpoint(this.competitor_sr_id_home), 
                { crossdomain: true })
            .then((response) => {
                
                console.log('competitor_summaries_home', response.data);

                this.competitor_summaries_home = response.data;
            
            }, (error) => {
                console.log(error)
            });

            axios.get(this.getCompetitorSummariesEndpoint(this.competitor_sr_id_away), 
                { crossdomain: true })
            .then((response) => {
                
                console.log('competitor_summaries_away', response.data);

                this.competitor_summaries_away = response.data;
            
            }, (error) => {
                console.log(error)
            });
        },

        loadH2H: function() {

            if(this.getH2HEndpoint() == '') return;

            axios.get(this.getH2HEndpoint(), 
                { crossdomain: true })
            .then((response) => {
                
                console.log('competitor vs competitor', response.data);
                this.h2h = response.data;

            }, (error) => {
                console.log(error)
            });
        },

        getSportEventName: function(sport_event) {

            let name = sport_event.home.name + ' vs ' + sport_event.away.name;

            return name;
        },

        selectYear: function(event) {
			
			this.year = event.target.value;
			this.loadSchedule();
        },

        selectSeason: function(event) {
			
			this.season = event.target.value;
			this.loadSchedule();
        },

        selectSportEvent: function(event) {
			  
            let sportEventId = event.target.value;
            let sport_event = '';
            let week = '';

                
            let temp_sport_event = this.schedule.games.find(function(game) {
                return game.id == sportEventId;
            });

            if(temp_sport_event) {
                sport_event = temp_sport_event;
            }

            this.sportEventId = event.target.value;
            this.sport_event = sport_event;
            this.home = sport_event.home;
            this.away = sport_event.away;
            if(this.sport_event.home.sr_id && this.sport_event.away.sr_id ){
                this.competitor_sr_id_home = this.sport_event.home.sr_id.replace('team', 'competitor');
                this.competitor_sr_id_away = this.sport_event.away.sr_id.replace('team', 'competitor');
            }

            this.loadPlayByPlay();	
            this.loadGameBoxscore();
            this.loadGameSummary();
            this.loadInjuries();
            this.loadSeasonalStatistics();
            this.loadTeamRoster();
            this.loadSplitsGame();
            this.loadSplitsHierarchy();
            this.loadSplitsSchedule();
            this.loadSplitsInGame();
            this.loadCompetitorSummaries();
            this.loadH2H();
        },

        selectPlayer: function(event) {

            this.playerId = event.target.value;

			this.loadPlayerProfile();
        },
    },
}
</script>
